var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 23.99",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .info-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "038") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interface-Essential_Select_cursor-double-click-3",
    "data-name": "Interface-Essential / Select / cursor-double-click-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cursor-double-click-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_2737",
    "data-name": "Shape 2737",
    className: "info-1",
    d: "M10.54,11.56l2.68,8.94a.81.81,0,0,0,.59.56.83.83,0,0,0,.79-.22L16,19.48,19.49,23a.78.78,0,0,0,.58.24.82.82,0,0,0,.59-.24L23,20.65a.83.83,0,0,0,.24-.58.87.87,0,0,0-.24-.59L19.49,16l1.36-1.36a.83.83,0,0,0,.22-.79.84.84,0,0,0-.57-.6l-8.93-2.68a.85.85,0,0,0-.82.21A.81.81,0,0,0,10.54,11.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2738",
    "data-name": "Shape 2738",
    className: "info-1",
    d: "M21.72,10.5A10.5,10.5,0,1,0,10.5,21.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2739",
    "data-name": "Shape 2739",
    className: "info-1",
    d: "M16.81,9A6,6,0,1,0,9,16.81"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.da8f493ca06b8ac62ff302ca952199a2.svg";
export { ForwardRef as ReactComponent };